import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject} from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Pagination } from 'src/app/infraestructure/interfaces/pagination/pagination.DTO';
import { ParametersDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { Solicitud } from 'src/app/infraestructure/interfaces/referente/SolicitudDTO';
import { ConsultaBandejaProgramadorI } from 'src/app/infraestructure/models/consultaBandejaProgramador.interface';
import { PaginationI } from 'src/app/infraestructure/models/pagination.interface';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';
import { ProgrammerApiService } from 'src/app/infraestructure/services/programmer/programmer-api.service';
import { ReferentApiService } from 'src/app/infraestructure/services/referent/referent-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bandeja-programador',
  templateUrl: './bandeja-programador.component.html',
  styleUrls: ['./bandeja-programador.component.scss']
})
export class BandejaProgramadorComponent implements OnInit {

  $parametricList: ParametersDTO = new ParametersDTO();
  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;

  paginationResponse = {} as PaginationI;
  dataSearch = {} as Pagination;
  dataTable: ConsultaBandejaProgramadorI[] = [];

  rolId: number = 0;
  userId: number = 0;
  submitted: number = 0;
  showRequest: boolean = false;

  constructor(private _listSrv: ParametricListsService,
              private store: Store<AppState>,
              private programmerSrv: ProgrammerApiService,
              public router: Router,
              private _referentSrv: ReferentApiService) 
  {
    this.user$ = this.store.select(state => state.user);
  }
  
  ngOnInit(): void {

    this.user$.pipe(
      takeUntil(this.$topSubcription)
    )
    .subscribe(user => {
      if (user.id > 0) {
        this.userId = user.id;
        this.rolId = user.rolId;

        this.dataSearch.itemsPorPagina = 5;
        this.dataSearch.numeroPagina = 1;
        this.dataSearch.rolId = this.rolId;
  
        this.getParametroTipoFecha();
      }
    });

  }

  getParametroTipoFecha() {
    this._listSrv.getDataLists('TIP_FILTROS_FECHA')
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code == 200) this.$parametricList.typeFilterDate = res.data;
      });
  }

  onSearchDates() {
    this.programmerSrv.postSolicitudConsultBandProgram(this.dataSearch)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      if(res.code === 200) {
        this.paginationResponse = {
          itemsPage: res.data.itemsPage,
          page: res.data.number,
          pages: res.data.pages
        }
        
        this.dataTable = res.data.data;
      } else {
        const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
        Swal.fire({
          title: 'Errores',
          icon: 'error',
          html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
          showConfirmButton: true,
          confirmButtonColor: "#004884",
          confirmButtonText: "ACEPTAR",
        });
      } 
    });
  }

  getSolicitudes(paginationReq: Pagination) {
    paginationReq.rolId = this.rolId;
    paginationReq.dtFechaFinal = this.dataSearch.dtFechaFinal;
    paginationReq.dtFechaInicial = this.dataSearch.dtFechaInicial;
    paginationReq.tipoFiltroId = this.dataSearch.tipoFiltroId;
    this.programmerSrv.postSolicitudConsultBandProgram(paginationReq)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.paginationResponse = {
            itemsPage: res.data.itemsPage,
            page: res.data.number,
            pages: res.data.pages
          }
          this.dataSearch.itemsPorPagina = res.data.itemsPage;
          this.dataSearch.numeroPagina = res.data.number;

          this.dataTable = res.data.data;
        }
      });
  }

  onShowRequest() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
      text: `Está seguro de radicar una solicitud de servicio extemporánea`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#2BA3BF",
      confirmButtonText: "ACEPTAR",
      cancelButtonText: 'CANCELAR'
    }).then((result) => {
      if (result.isConfirmed) {
        this.showRequest = true;
      }
    });
  }

  /** =============================================================================== */

  saveRequestService() {
    this.submitted += 1;
  }

  catchRequestService(event: Solicitud) {

    this._referentSrv.postRequestService(event)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe((res: any) => {
        if (res.code == 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: `Creación exitosa`,
            text: `Solicitud de servicio extemporánea creada exitosamente con el #${res.data.id}`,
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });

          const currentUrl = this.router.url;
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        } else {
          const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
          Swal.fire({
            title: 'Errores',
            icon: 'error',
            html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
        }
      });
  }
}
